import { PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import { manualInvestmentsSearchSchema } from '@/hooks/queries/crt/useManualInvestments'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { CreateManualInvestmentDialog } from './-components/CreateManualInvestmentDialog'
import { ManualInvestmentsDataTable } from './-components/ManualInvestmentsDataTable'

export const Route = createFileRoute(
  '/_auth/_modules/crt/customer-investments/data-sources/manual-investments/',
)({
  component: RouteComponent,
  validateSearch: (search) => manualInvestmentsSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('manualInvestments.pageHeader')}</PageHeader>
        <PermissionsGuard required={['crt_manual_investments_create']}>
          <CreateManualInvestmentDialog />
        </PermissionsGuard>
      </Spread>

      <Card>
        <CardHeader>
          <CardTitle>{t('manualInvestments.cardTitle')}</CardTitle>
        </CardHeader>

        <CardContent>
          <VStack gap="md">
            <ManualInvestmentsDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
